import { useEffect, useState, useRef } from "react";
import { OrderFeedbackModal } from "./orderFeedbackModal";

/**
 * Глобальный компонент для управления показом модалки обратной связи
 * Слушает команды от бэкенда через WebSocket и показывает модалку по команде
 */
export function OrderFeedbackManager() {
  const [pendingOrderNumber, setPendingOrderNumber] = useState<string | null>(null);
  const shownOrdersRef = useRef<Set<string>>(new Set());

  useEffect(() => {
    // Слушаем события feedback_request от WebSocket клиента
    const handleFeedbackRequest = (event: CustomEvent<{ order_number: string }>) => {
      const orderNumber = event.detail.order_number;
      
      // Проверяем, не показывали ли мы уже модалку для этого заказа
      if (!shownOrdersRef.current.has(orderNumber)) {
        setPendingOrderNumber(orderNumber);
        shownOrdersRef.current.add(orderNumber);
      }
    };

    window.addEventListener("feedback_request", handleFeedbackRequest as EventListener);

    return () => {
      window.removeEventListener("feedback_request", handleFeedbackRequest as EventListener);
    };
  }, []);

  const handleClose = () => {
    setPendingOrderNumber(null);
  };

  if (!pendingOrderNumber) {
    return null;
  }

  return (
    <OrderFeedbackModal
      orderNumber={pendingOrderNumber}
      isOpen={true}
      onClose={handleClose}
    />
  );
}
